/** 绿化分支 **/
import Layout from "@/views/layout/Layout";
// component: () => import("@/views/hrMan/orgPlan/index"),
const examRouter = {
  path: "/deviceMan",
  component: Layout,
  redirect: "/examMan/course/list",
  name: "deviceMan",
  meta: {
    title: "设备管理",
    icon: "deviceMan",
    roles: ["equ_shebeiguanli"],
  },

  children: [
    {
      path: "deviceFileMan",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "deviceFileMan",
      meta: {
        title: "设备档案管理",
        roles: ["equ_shebeidanganguanli"],
      },
      children: [
        {
          path: "basicledgerMain",
          component: () =>
            import("@/views/deviceMan/deviceFileMan/basicledgerMain/index"),
          name: "basicledgerMain",
          meta: {
            title: "设备信息维护",
            roles: ["equ_jichutaizhangweihu"],
          },
          children: [],
        },
        {
          path: "equManualMan",
          component: () =>
            import("@/views/deviceMan/deviceFileMan/equManualMan/index"),
          name: "equManualMan",
          meta: {
            title: "操作手册管理",
            roles: ["equ_caozuoshouceguanli"],
          },
          children: [],
        },
        {
          path: "deviceOperRecords",
          component: () =>
            import("@/views/deviceMan/deviceFileMan/deviceOperRecords/index"),
          name: "deviceOperRecords",
          meta: {
            title: "设备运行记录",
            roles: ["equ_shebeiyunxingjilu"],
          },
          children: [],
        },

        {
          path: "runningRecordTempMan",
          component: () =>
            import(
              "@/views/deviceMan/deviceFileMan/runningRecordTempMan/index"
            ),
          name: "runningRecordTempMan",
          meta: {
            title: "运行模板管理",
            roles: ["equ_yunxingjilumobanguanli"],
          },
          children: [],
        },
        {
          path: "MainItemsList",
          component: () =>
            import("@/views/deviceMan/deviceFileMan/MainItemsList/index"),
          name: "MainItemsList",
          meta: {
            title: "检修事项维护",
            roles: ["equ_jianxiushixiangweihu"],
          },
          children: [],
        },
        {
          path: "mainSubjectCategory",
          component: () =>
            import("@/views/deviceMan/deviceFileMan/mainSubjectCategory/index"),
          name: "mainSubjectCategory",
          meta: {
            title: "维修科目维护",
            roles: ["equ_weixiukemuleibieweihu"],
          },
          children: [],
        },
        {
          path: "mainEquPosition",
          component: () =>
            import("@/views/deviceMan/deviceFileMan/mainEquPosition/index"),
          name: "mainEquPosition",
          meta: {
            title: "设备地址维护",
            roles: ["equ_shebeidizhiweihu"],
          },
          children: [],
        },

        {
          path: "formProcessDesign",
          component: () =>
            import(
              "@/views/deviceMan/deviceFileMan/runningRecordTempMan/dyFormDesign/index"
            ),
          name: "formProcessDesign",
          meta: {
            title: "运行记录模板设置",
            roles: ["equ_yunxingjilumobanguanli"],
          },
          hidden: true,
          children: [],
        },
      ],
    },
    {
      path: "deviceMainRepair",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "deviceMainRepair",
      meta: {
        title: "设备保养检修",
        roles: ["equ_shebeibaoyangjianxiu"],
      },
      children: [
        {
          path: "deviceMain",
          component: () => import("@/views/hrMan/orgPlan/index"),
          name: "deviceMain",
          meta: {
            title: "设备保养",
            roles: ["equ_shebeibaoyang"],
          },
          children: [
            {
              path: "mainPlan",
              component: () =>
                import(
                  "@/views/deviceMan/deviceMainRepair/deviceMain/mainPlan/index"
                ),
              name: "mainPlan",
              meta: {
                title: "保养计划",
                roles: ["equ_baoyangjihua"],
              },
              children: [],
            },
            {
              path: "mainPlanExe",
              component: () =>
                import(
                  "@/views/deviceMan/deviceMainRepair/deviceMain/mainPlanExe/index"
                ),
              name: "mainPlanExe",
              meta: {
                title: "保养计划执行",
                roles: ["equ_baoyangjihuazhixing"],
              },
              children: [],
            },
            {
              path: "mainPlanExeMan",
              component: () =>
                import(
                  "@/views/deviceMan/deviceMainRepair/deviceMain/mainPlanExeMan/index"
                ),
              name: "mainPlanExeMan",
              meta: {
                title: "保养执行记录",
                roles: ["equ_baoyangzhixingjilu"],
              },
              children: [],
            },
          ],
        },
        {
          path: "deviceRepair",
          component: () => import("@/views/hrMan/orgPlan/index"),
          name: "deviceRepair",
          meta: {
            title: "设备检修",
            roles: ["equ_shebeijianxiu"],
          },
          children: [
            {
              path: "mainPlan",
              component: () =>
                import(
                  "@/views/deviceMan/deviceMainRepair/deviceRepair/mainPlan/index"
                ),
              name: "mainPlan",
              meta: {
                title: "检修计划",
                roles: ["equ_jianxiujihua"],
              },
              children: [],
            },
            {
              path: "mainPlanExe",
              component: () =>
                import(
                  "@/views/deviceMan/deviceMainRepair/deviceRepair/mainPlanExe/index"
                ),
              name: "mainPlanExe",
              meta: {
                title: "检修计划执行",
                roles: ["equ_jianxiujihuazhixing"],
              },
              children: [],
            },
            {
              path: "mainPlanExeMan",
              component: () =>
                import(
                  "@/views/deviceMan/deviceMainRepair/deviceRepair/mainPlanExeMan/index"
                ),
              name: "mainPlanExeMan",
              meta: {
                title: "检修执行记录",
                roles: ["equ_jianxiuzhixingjilu"],
              },
              children: [],
            },
          ],
        },
        {
          path: "deviceMaintainableMan",
          component: () => import("@/views/hrMan/orgPlan/index"),
          name: "deviceMaintainableMan",
          meta: {
            title: "设备维修",
            roles: ["equ_shebeiweixiuguanli"],
          },
          children: [
            {
              path: "equPlan",
              component: () =>
                import(
                  "@/views/deviceMan/deviceMainRepair/equMain/equPlan/index"
                ),
              name: "equPlan",
              meta: {
                title: "设备维修",
                roles: ["equ_shebeiweixiu"],
              },
              children: [],
            },
            {
              path: "equMan",
              component: () =>
                import(
                  "@/views/deviceMan/deviceMainRepair/equMain/equMan/index"
                ),
              name: "equMan",
              meta: {
                title: "设备维修记录",
                roles: ["equ_shebeiweixiujilu"],
              },
              children: [],
            },
          ],
        },
      ],
    },
    {
      path: "technicalDataMan",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "technicalDataMan",
      meta: {
        title: "技术资料管理",
        roles: ["equ_jishuziliao"],
      },
      children: [
        {
          path: "createTechnicalData",
          component: () =>
            import(
              "@/views/deviceMan/technicalDataMan/createTechnicalData.vue"
            ),
          name: "createTechnicalData",
          meta: {
            title: "技术资料创建",
            roles: ["equ_jishuziliaochuangjian"],
          },
          children: [],
        },
        {
          path: "viewTechnicalData",
          component: () =>
            import("@/views/deviceMan/technicalDataMan/viewTechnicalData.vue"),
          name: "viewTechnicalData",
          meta: {
            title: "技术资料查看",
            roles: ["equ_jishuziliaochakan"],
          },
          children: [],
        },
        {
          path: "manageTechnicalData",
          component: () =>
            import(
              "@/views/deviceMan/technicalDataMan/manageTechnicalData.vue"
            ),
          name: "manageTechnicalData",
          meta: {
            title: "技术资料管理",
            roles: ["equ_jishuziliaoguanli"],
          },
          children: [],
        },
      ],
    },
    {
      path: "reportMan",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "reportMan",
      meta: {
        title: "报表管理",
        roles: ["equ_baobiaoguanli"],
      },
      children: [
        {
          path: "deviceMainRepair",
          component: () =>
            import("@/views/deviceMan/reportMan/deviceMainRepair/index"),
          name: "deviceMainRepair",
          meta: {
            title: "设备保养、检修信息",
            roles: ["equ_shebeibaoyangjianxiuxinxi"],
          },
          children: [],
        },

        {
          path: "maintenanceIssueStatistics",
          component: () =>
            import("@/views/deviceMan/reportMan/maintenanceIssueStatistics/index"),
          name: "maintenanceIssueStatistics",
          meta: {
            title: "保养问题统计",
            roles: ["equ_baoyangwentitongji"],
          },
          children: [],
        },

        {
          path: "equOperRecords",
          component: () => import("@/views/hrMan/orgPlan/index"),
          name: "equOperRecords",
          meta: {
            title: "设备运行记录统计",
            roles: ["equ_shebeiyunxingjilutongji"],
          },
          children: [
            {
              path: "deviceOperRecords",
              component: () =>
                import("@/views/deviceMan/reportMan/deviceOperRecords/index"),
              name: "deviceOperRecords",
              meta: {
                title: "设备运行信息",
                roles: ["equ_shebeiyunxingxinxitongji"],
              },
              children: [],
            },
            {
              path: "month",
              component: () =>
                import("@/views/deviceMan/reportMan/equOperRecords/month.vue"),
              name: "month",
              meta: {
                title: "月度统计",
                roles: ["equ_shebeiyuedutongji"],
              },
              children: [],
            },
          ],
        },
      ],
    },

    // {
    //   path: "mbInitiateProcess",
    //   component: () =>
    //     import("@/views/deviceMan/dynamicForm/MbInitiateProcess"),
    //   name: "创建记录",
    //   meta: {
    //     title: "创建记录"
    //   },
    //   hidden: true,
    //   children: []
    // }

    //
  ],
};

export default examRouter;
